import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_URL } from "../../../constants";

const { RangePicker } = DatePicker;
const dateFormat = "DD-MM-YYYY";

export const TarifForm = ({ initialValues, onCreate, onUpdate, onCancel }) => {
  const [form] = Form.useForm();
  const [services, setServices] = useState([]);
  const accessToken = useSelector(
    (state) => state.user.currentUser?.accessToken
  );

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        date: [dayjs(initialValues?.startDate), dayjs(initialValues?.endDate)],
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const onFinish = (values) => {
    const { date, ...rest } = values;
    const startDateUTC = date[0].startOf('day').toDate().toISOString();
    const endDateUTC = date[1].endOf('day').toDate().toISOString();

    const myValues = {
      id: initialValues?.id,
      ...rest,
      startDate: startDateUTC,
      endDate: endDateUTC,
    };
    console.log({ myValues });
    if (initialValues) onUpdate(myValues);
    else onCreate(myValues);
    form.resetFields();
  };
  const getServices = async () => {
    try {
      const res = await axios.get(API_URL + "user/services", {
        headers: { Authorization: "Bearer " + accessToken },
      });
      setServices(
        res.data.map((serv) => ({
          label: serv.NAMESERVIC,
          value: serv.SERVICEID,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      // initialValues={{
      //   SERVICEID: undefined,
      //   value: undefined,
      //   startDate: dayjs(),
      //   endDate: null,
      //   description: "",
      // }}
    >
      {/* SERVICEID */}
      <div className="d-flex w-100 gap-2 justify-content-between">
        <Form.Item
          name="SERVICEID"
          label="Service ID"
          className="w-100"
          rules={[{ required: true, message: "Please enter a service ID" }]}
        >
          <Select style={{ width: "100%" }} options={services} />
        </Form.Item>

        {/* Value */}
        <Form.Item
          name="value"
          label="Value"
          className="w-100"
          rules={[{ required: true, message: "Please enter a value" }]}
        >
          <InputNumber style={{ width: "100%" }} step={0.01} />
        </Form.Item>
      </div>
      {/* Start Date */}
      <Form.Item
        name="date"
        label="Date"
        rules={[{ required: true, message: "Please select a date range" }]}
      >
        <RangePicker
          style={{ width: "100%" }}
          placeholder={["Data de începere", "Data finală"]}
          format={dateFormat}
        />
      </Form.Item>

      {/* Description (optional) */}
      <Form.Item name="description" label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
        <Button
          type="primary"
          danger
          onClick={() => {
            onCancel();
            form.resetFields();
          }}
          style={{ marginLeft: 12, color: "white" }}
        >
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
};
